module.exports = __webpack_public_path__ + "static/media/adjustable_headrest.ee2e75bc.mp4";